module.exports = __webpack_public_path__ + "img/person3-small@2x.23e49233.png";